import React, { useContext, useEffect, useState } from "react";
import "./Guest_house_booking_modal.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Pink_Btn from "../../common_btn/pink_btn/Pink_Btn";
import Successfull_Lottie from "../../../animation/successfull_lottie/Successfull_Lottie";
import Success_Modal from "../../common_modal/success_modal/Success_Modal";
import Successfull_Modal from "../common-modal/successfull_modal/Successfull_Modal";
import { useNavigate } from "react-router-dom";
import { Controller, useFieldArray, useForm, useWatch } from "react-hook-form";
import Select from "react-select";
import { CheckAvailability } from "../../../../features/admin/room/slice";
import { useDispatch } from "react-redux";
import { Context } from "../../../../utils/context";
import { decodeId, encodeId, formatDate, formatTimeAMPM } from "../../../../utils/common";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";

import { TimePicker } from "@mui/x-date-pickers/TimePicker";

dayjs.extend(isSameOrAfter);

const Guest_house_booking_modal = ({ room, ...props }) => {
  const {
    control,
    reset,
    watch,
    register,
    setError,
    setValue,
    handleSubmit,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      guest_details: [{ name: "", age: "", gender: "" }],
    },
  });

  console.log(errors);

  const navigate = useNavigate();
  const { bookingData, setBookingData } = useContext(Context);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showSuccessfullModal, setShowSuccessfullModal] = useState(false);
  const [checkInTime, setCheckInTime] = useState(null);
  const [checkOutTime, setCheckOutTime] = useState(null);

  const guestDetails = watch("guest_details") || [];

  const basePersons = room?.base_persons || 0;
  const capacity = room?.capacity || 0;

  const totalGuests = guestDetails.length;
  const extraPersons = Math.max(0, totalGuests - basePersons);
  const maxExtraAllowed = Math.max(0, capacity - basePersons);

  const facilities =
    useWatch({
      control,
      name: "facilities",
    }) || [];

  // const [facilityTotal, setFacilityTotal] = useState(0);

  useEffect(() => {
    if (!room?.Facilities?.length) return;

    const facilitiesWithSelection = room.Facilities.map((f) => ({
      id: f.id,
      name: f.name,
      price: Number(f.price || 0),
      selected: true, // ✅ default checked
    }));

    setValue("facilities", facilitiesWithSelection);
  }, [room, setValue]);

  const facilityTotal = facilities.reduce(
    (sum, f) => (f?.selected ? sum + Number(f.price || 0) : sum),
    0,
  );

  useEffect(() => {
    if (!capacity) return;

    if (totalGuests > capacity) {
      setError("guest_details", {
        type: "manual",
        message: `Maximum ${capacity} guests allowed in this room`,
      });
    } else {
      clearErrors("guest_details");
    }
  }, [totalGuests, capacity]);

  const dispatch = useDispatch();

  // useEffect(() => {
  //     if (room) {
  //         const { capacity, base_persons } = room;

  //         // ADULT OPTIONS (adults cannot exceed capacity)
  //         const adultsArr = Array.from({ length: base_persons }, (_, i) => ({
  //             value: i + 1,
  //             label: `${i + 1} Adult${i + 1 > 1 ? "s" : ""}`,
  //         }));
  //         setAdultOptions(adultsArr);

  //         // CHILDREN OPTIONS (children + adults cannot exceed capacity)
  //         const childrenArr = Array.from({ length: base_persons }, (_, i) => ({
  //             value: i,
  //             label: `${i} Child${i > 1 ? "ren" : ""}`,
  //         }));
  //         setChildrenOptions(childrenArr);

  //         // Initial extra person options
  //         const maxExtra = capacity - base_persons;
  //         const extraArr = Array.from({ length: maxExtra }, (_, i) => ({
  //             value: i + 1,
  //             label: `${i + 1} Extra Person`,
  //         }));
  //         setExtraPersonOptions(extraArr);
  //     }
  // }, [room]);

  // useEffect(() => {
  //     if (!room) return;

  //     const { capacity, base_persons } = room;

  //     const adultsVal = Number(adults?.value) || 0;
  //     const childrenVal = Number(children?.value) || 0;
  //     const extraVal = Number(watch("extra_persons")) || 0;

  //     const totalGuests = adultsVal + childrenVal;
  //     const remaining = capacity - totalGuests;

  //     const adultArr = Array.from({ length: base_persons }, (_, i) => ({
  //         value: i + 1,
  //         label: `${i + 1} Adult${i + 1 > 1 ? "s" : ""}`,
  //     }));
  //     setAdultOptions(adultArr);

  //     if (adultsVal > capacity) {
  //         setError("adults", {
  //             type: "manual",
  //             message: `Limit Excceeded`
  //         });
  //         setValue("adults", capacity);
  //     }

  //     const childArr = Array.from({ length: base_persons + 1 }, (_, i) => ({
  //         value: i + 1,
  //         label: `${i + 1} Child${i + 1 > 1 ? "ren" : ""}`,
  //     }));
  //     setChildrenOptions(childArr);

  //     const maxChildrenAllowed = capacity - adultsVal;
  //     if (childrenVal > maxChildrenAllowed) {
  //         setError("children", {
  //             type: "manual",
  //             message: `Limit Excceeded`
  //         });
  //         setValue("children", maxChildrenAllowed);
  //     }

  //     const maxExtraByRoom = capacity - base_persons;

  //     const maxExtraBySpace = remaining;

  //     const finalExtra = Math.min(maxExtraByRoom, maxExtraBySpace);

  //     const extraArr = Array.from({ length: finalExtra }, (_, i) => ({
  //         value: i + 1,
  //         label: `${i + 1} Extra Person`,
  //     }));

  //     setExtraPersonOptions(extraArr);

  //     if (extraVal > finalExtra) {
  //         setValue("extra_persons", finalExtra > 0 ? finalExtra : "");
  //     }

  // }, [adults, children, watch("extra_persons"), room]);

  const handleCheckAvailability = async (data) => {
    console.log("data:", data);

    const sendData = new FormData();

    const formattedCheckInTime = data?.check_in_time
      ? data.check_in_time.format("HH:mm")
      : null;

    const formattedCheckOutTime = data?.check_out_time
      ? data.check_out_time.format("HH:mm")
      : null;


    // sendData.append("adults", data?.adults?.value);
    // sendData.append("children", data?.children?.value);
    sendData.append("check_in_date", data?.check_in_date);
    sendData.append("check_out_date", data?.check_out_date);
    sendData.append("check_in_time", formattedCheckInTime);
    sendData.append("check_out_time", room?.check_out_time);


    const sendData2 = {
      check_in_date: data?.check_in_date,
      check_out_date: data?.check_out_date,
      check_in_time: formattedCheckInTime,
      check_out_time: room?.check_out_time,
    }

    // if (data?.extra_persons) {
    //     sendData.append("extra_persons", data?.extra_persons?.value);
    // }

    // Log formdata properly
    for (let pair of sendData.entries()) {
      console.log(pair[0], pair[1]);
    }

    const res = await dispatch(CheckAvailability({ id: room?.id, data: sendData2 }));

    if (res.meta?.requestStatus === "fulfilled") {
      const selectedFacilities = facilities.filter((f) => f.selected);

      setBookingData((prev) => ({
        ...prev,
        facilities: selectedFacilities,
        facility_total: facilityTotal,
        check_in_date: data.check_in_date,
        check_out_date: data.check_out_date,
        check_in_time: formattedCheckInTime,
        check_out_time: room?.check_out_time,
        extra_persons: extraPersons,
        guests_count: data.guest_details.length,
        guest_details: data.guest_details,
      }));


      props.onHide();
      setShowSuccessModal(true);
      setTimeout(() => {
        setShowSuccessModal(false);
        navigate(`/checkout-room/${encodeId(room?.id)}`);
      }, 3000);
    } else if (res.meta?.requestStatus === "rejected") {

      if (res?.payload?.errors?.check_in_time) {
        setError("check_in_time", {
          type: "manual",
          message: res.payload.errors.check_in_time,
        });
        return;
      }
      if (res?.payload?.errors?.check_out_time) {
        setError("check_out_time", {
          type: "manual",
          message: res.payload.errors.check_out_time,
        });
        return;
      }

      if (res?.payload?.errors?.message || res?.payload?.errors) {
        alert(
          `${res?.payload?.errors?.message ||
          res?.payload?.errors ||
          "Somthing Went Wrong"}`,
        );
      }
    }
  };

  const handleShowSuccessfullModal = () => {
    setShowSuccessModal(false);
    // setShowSuccessfullModal(true);

    setTimeout(() => {
      // setShowSuccessfullModal(false);
      navigate(`/checkout-room/${encodeId(room?.id)}`);
    }, 5000);
  };

  const { fields, append, remove } = useFieldArray({
    control,
    required: "Please add at least one guest",
    name: "guest_details",
  });

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="common_modal Success_Modal Guest_house_booking_modal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Guest House Booking
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="row">
              {/* Check-in Date */}
              <div className="col-md-6 mb-2">
                <div className="form-group">
                  <Form.Label>Check In Date</Form.Label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Controller
                      name="check_in_date"
                      control={control}
                      rules={{
                        required: "Check In Date is required",
                        validate: (value) => {
                          if (!value) return true;

                          const selectedDate = dayjs(value);
                          const today = dayjs().startOf("day");

                          if (selectedDate.isBefore(today)) {
                            return "Past date is not allowed";
                          }

                          return true;
                        },
                      }}
                      render={({ field }) => (
                        <DatePicker
                          label="Select Check In Date"
                          minDate={dayjs()}
                          value={field.value ? dayjs(field.value) : null}
                          onChange={(newValue) => {
                            const formattedDate = newValue
                              ? newValue.format("YYYY-MM-DD")
                              : null;
                            field.onChange(formattedDate);
                          }}
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              error: !!errors?.check_in_date,
                              helperText: errors?.check_in_date?.message,
                            },
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </div>
              </div>

              {/* Check-out Date */}
              <div className="col-md-6 mb-2">
                <div className="form-group">
                  <Form.Label>Check Out Date</Form.Label>

                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Controller
                      name="check_out_date"
                      control={control}
                      rules={{
                        required: "Check-out date is required",
                        validate: (value) => {
                          const checkIn = watch("check_in_date");

                          if (!checkIn) return true;

                          return dayjs(value).isSameOrAfter(dayjs(checkIn))
                            || "Check-out must be same or after check-in";
                        }
                      }}


                      render={({ field }) => (
                        <DatePicker
                          label="Select Check Out Date"
                          minDate={dayjs()}
                          value={field.value ? dayjs(field.value) : null}
                          onChange={(newValue) => {
                            const formattedDate = newValue
                              ? newValue.format("YYYY-MM-DD")
                              : null;
                            field.onChange(formattedDate);
                          }}
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              error: !!errors?.check_out_date,
                              helperText: errors?.check_out_date?.message,
                            },
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>

                </div>
              </div>

              {/* Check-in Time */}
              <div className="col-md-6 mb-2">
                <div className="form-group">
                  <Form.Label>Check In Time</Form.Label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Controller
                      name="check_in_time"
                      control={control}
                      rules={{ required: "Check-In time is required" }}
                      render={({ field, fieldState }) => (
                        <TimePicker
                          label="Select Check In Time"
                          value={field.value || null}
                          onChange={(newValue) => field.onChange(newValue)} // ✅ keep Dayjs
                          format="hh:mm A" // ✅ AM/PM format
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              error: !!fieldState.error,
                              helperText: fieldState.error?.message,
                            },
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>

                  {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Controller
                      name="check_in_time"
                      control={control}
                      rules={{
                        required: "Check-In time is required",
                      }}
                      render={({ field, fieldState }) => (
                        <TimePicker
                          label="Select Check In Time"
                          value={field.value || null}
                          onChange={(newValue) =>
                            field.onChange(
                              newValue ? newValue.format("HH:mm") : null
                            )
                          }
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              // error: !!fieldState.error,
                              // helperText: fieldState.error?.message,
                            },
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider> */}

                </div>
              </div>

              {/* Check-out Time */}
              <div className="col-md-6 mb-2">
                <div className="form-group">
                  <Form.Label>Check Out Time</Form.Label>

                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Controller
                      name="check_out_time"
                      control={control}
                      render={({ field }) => (
                        <TimePicker
                          label="Check Out Time"
                          value={
                            room?.check_out_time
                              ? dayjs(room.check_out_time, "HH:mm:ss")
                              : null
                          }
                          format="hh:mm A"
                          disabled
                          slotProps={{
                            textField: {
                              fullWidth: true,
                            },
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>

                  <Form.Text className="text-muted">
                    <strong>Checkout Time:</strong>{" "}
                    {formatTimeAMPM(room?.check_out_time)}
                  </Form.Text>
                </div>
              </div>

              <div className="col-12 mt-3">
                <h6>Guest Details</h6>

                {fields.map((item, index) => (
                  <div key={item.id} className="border rounded p-3 mb-2">
                    <div className="row align-items-start">
                      {/* Name */}
                      <div className="col-md-4 mb-2">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                          placeholder="Guest Name"
                          {...register(`guest_details.${index}.name`, {
                            required: "Name is required",
                            minLength: {
                              value: 3,
                              message: "Name must be at least 3 characters",
                            },
                            maxLength: {
                              value: 50,
                              message: "Name cannot exceed 50 characters",
                            },
                            pattern: {
                              value: /^[A-Za-z\s]+$/,
                              message: "Name can only contain letters and spaces",
                            },
                          })}
                        />

                        {errors?.guest_details?.[index]?.name && (
                          <Form.Text className="text-danger">
                            {errors.guest_details[index].name.message}
                          </Form.Text>
                        )}
                      </div>

                      {/* Age */}
                      <div className="col-md-3 mb-2">
                        <Form.Label>Age</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Age"
                          inputMode="numeric"
                          maxLength={3}
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, "");
                          }}
                          {...register(`guest_details.${index}.age`, {
                            required: "Age is required",
                            setValueAs: (v) => (v === "" ? "" : Number(v)),
                            min: {
                              value: 1,
                              message: "Age must be between 1 and 150",
                            },
                            max: {
                              value: 150,
                              message: "Age cannot be greater than 150",
                            },
                          })}
                        />

                        {errors?.guest_details?.[index]?.age && (
                          <Form.Text className="text-danger">
                            {errors.guest_details[index].age.message}
                          </Form.Text>
                        )}
                      </div>

                      {/* Gender */}
                      <div className="col-md-3 mb-2">
                        <Form.Label>Gender</Form.Label>
                        <Form.Select
                          {...register(`guest_details.${index}.gender`, {
                            required: "Gender is required",
                          })}
                        >
                          <option value="">Select</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                        </Form.Select>
                        {errors?.guest_details?.[index]?.gender && (
                          <Form.Text className="text-danger">
                            {errors.guest_details[index].gender.message}
                          </Form.Text>
                        )}
                      </div>

                      {/* Remove */}
                      <div className="col-md-2 mb-2 text-end">
                        {fields.length > 1 && (
                          <button
                            type="button"
                            className="btn btn-outline-danger btn-sm"
                            onClick={() => remove(index)}
                          >
                            Remove
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
                <div className="col-md-6 mb-2">
                  <div className="col-md-6 mb-2">
                    {/* Add Guest */}
                    <button
                      disabled={totalGuests >= capacity}
                      type="button"
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => append({ name: "", age: "", gender: "" })}
                    >
                      +{" "}
                      {totalGuests >= basePersons
                        ? "Add Extra Guest"
                        : "Add Guest"}
                    </button>
                  </div>
                  {errors?.guest_details && (
                    <Form.Text className="text-danger">
                      {errors.guest_details.message}
                    </Form.Text>
                  )}
                </div>

                <div className="col-12 mb-2">
                  {room?.Facilities?.length > 0 && (
                    <div className="col-12 mt-4">
                      <h6>Room Facilities</h6>

                      <div className="border rounded p-3">
                        {room.Facilities.map((facility, index) => (
                          <div
                            key={facility.id}
                            className="d-flex justify-content-between align-items-center mb-2"
                          >
                            <Form.Check
                              type="checkbox"
                              label={facility.name}
                              {...register(`facilities.${index}.selected`)}
                              defaultChecked
                            />

                            <span className="text-muted">
                              ₹{facility.price || 0}
                            </span>

                            {/* hidden fields to preserve data */}
                            <input
                              type="hidden"
                              {...register(`facilities.${index}.id`)}
                              value={facility.id}
                            />
                            <input
                              type="hidden"
                              {...register(`facilities.${index}.name`)}
                              value={facility.name}
                            />
                            <input
                              type="hidden"
                              {...register(`facilities.${index}.price`)}
                              value={facility.price}
                            />
                          </div>
                        ))}

                        <hr />

                        <div className="d-flex justify-content-between fw-bold">
                          <span>Facilities Total</span>
                          <span>₹{facilityTotal}</span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Extra Person */}
              <div className="col-md-6 mb-2">
                {extraPersons > 0 && (
                  <div className="col-md-6 mb-2">
                    <div className="form-group">
                      <Form.Label>Extra Persons</Form.Label>

                      <Form.Control
                        readOnly
                        value={`${extraPersons} Extra Person${extraPersons > 1 ? "s" : ""
                          }`}
                      />

                      <Form.Text className="text-muted">
                        ₹{room?.extra_person_charge || 0} × {extraPersons} = ₹
                        {(room?.extra_person_charge || 0) * extraPersons}
                      </Form.Text>
                    </div>
                  </div>
                )}
              </div>

              {/* Button */}
              <div className="col-12">
                <div className="row">
                  <div className="col-sm-5 col-8 mx-auto">
                    <Pink_Btn
                      btnText={"Check Availability"}
                      onClick={handleSubmit(handleCheckAvailability)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Success_Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        successText={"Guest House Available For Selected Slot"}
        btnname={"Proceed for Payment"}
        onClick={handleShowSuccessfullModal} // Add this prop
      />

      <Successfull_Modal
        show={showSuccessfullModal}
        onHide={() => setShowSuccessfullModal(false)}
        headtext={"Spiritual Stay Booking"}
        successfultext={"Guest House Booked Successfully!"}
        subtext={"See You Soon!"}
        subtext2={"Have a nice time ahead"}
      />
    </>
  );
};

export default Guest_house_booking_modal;
